'use client';

import { useState, useEffect } from "react";
import { FaChevronDown } from "react-icons/fa6";
import Image from "../../Image";
const AccordionLayout = ({
  title,
  accordionData,
  images,
  defaultOpenIndex = 0,
  isEven,
}) => {
  const [openIndex, setOpenIndex] = useState(defaultOpenIndex);

  useEffect(() => {
    setOpenIndex(defaultOpenIndex);
  }, [defaultOpenIndex]);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div
      className={`flex flex-col lg:flex-row gap-x-10 gap-y-5 mt-6 p-4 sm:p-6 lg:p-0 ${
        isEven ? "lg:flex-row-reverse" : "" // Reverse the order for odd indices
      }`}
    >
      <p className="lg:hidden text-2xl sm:text-3xl text-[--accent-light] lg:mt-5">
        {title}
      </p>
      {/* Image Section */}
      <div className="w-full lg:w-[43%] h-auto lg:h-[506px] rounded-lg overflow-hidden">
        <Image
          src={images}
          alt={title}
          className="w-full h-full object-cover object-left-top rounded-xl border border-color-97"
        />
      </div>

      {/* Accordion Section */}
      <div className=" w-full lg:w-[52%]">
        <p className="hidden lg:block text-2xl sm:text-3xl xl:text-4xl text-[--accent-light] mb-6 lg:mt-2">
          {title}
        </p>
        <div className="w-full">
          {accordionData.map((item, index) => (
            <div
              key={index}
              className={`rounded-lg overflow-hidden mb-3 bg-color-98 transition-all duration-100 border ${
                openIndex === index ? " border-[#96EA6366]" : "border-color-99"
              }`}
            >
              {/* Accordion Header */}
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full flex justify-between items-center py-3 px-4 sm:py-4 sm:px-6 text-white bg-color-98"
              >
                <span className="text-lg sm:text-xl lg:text-[23px] font-medium leading-[28.8px]">
                  {item.question}
                </span>
                <span
                  className={`text-slate-800 transition-transform duration-300 ${
                    openIndex === index ? "rotate-180" : ""
                  }`}
                >
                  <FaChevronDown className="w-4 h-4 text-[#FFFFFF]" />
                </span>
              </button>

              {/* Accordion Content */}
              <div
                className={`overflow-hidden transition-all duration-300 ease-in-out ${
                  openIndex === index ? "max-h-[200px] px-4 pb-4" : "max-h-0"
                }`}
              >
                <ul className="list-disc pl-5 space-y-2 text-white">
                  {(Array.isArray(item.answer)
                    ? item.answer
                    : [item.answer]
                  ).map((answer, idx) => (
                    <li
                      key={idx}
                      className="break-words whitespace-normal text-base sm:text-lg lg:text-[20px] leading-[28.8px]"
                    >
                      {answer}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AccordionLayout;
